// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
const header = document.getElementById('header');

(function(){

	//burger menu
	const burgerMenuBtn = document.querySelector('[data-burgeropen]');
	const burgerMenuClose = document.querySelector('[data-burgerclose]');
	const burgerMenu = document.querySelector('[data-burgermenu]');
	
	if(burgerMenu) {
		burgerMenuBtn.addEventListener('click', (e) =>{
			e.preventDefault();
			burgerMenu.classList.add('open');
			document.body.classList.add('no-scroll');
		});

		burgerMenuClose.addEventListener('click', (e) =>{
			e.preventDefault();
			burgerMenu.classList.remove('open');
			document.body.classList.remove('no-scroll');
		});
		document.getElementById("privary-navigation").addEventListener("click", (e) => {
			let target = e.target.closest("li");
	
			if (!target)
				return;
	
			target.classList.toggle("active");
		});
	}

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

	

	// LANGUAGE SELECTOR
	document.querySelectorAll('.header-languages__active').forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();

			if (document.querySelector('.header-languages__options')) {
				document.querySelector('.header-languages__options').classList.toggle('open');
			}
		});
	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	/* Accessibility script for the 'skip to content' link - handles browser focus initialization issues */
	const skipLink = document.querySelector('.skip-to-content');
	
	if (!skipLink) return;
	
	skipLink.addEventListener('click', function(e) {
		const targetId = this.getAttribute('href');
		const targetEl = document.querySelector(targetId);

		if (targetEl) {
			if (!targetEl.hasAttribute('tabindex')) {
				targetEl.setAttribute('tabindex', '-1');
			}
			targetEl.focus();
		}
	});
	
	document.documentElement.setAttribute('tabindex', '-1');
	
	window.addEventListener('keydown', function handleFirstTab(e) {
		if (e.key === 'Tab') {
			if (document.activeElement === document.body || document.activeElement === document.documentElement) {
				e.preventDefault();
				skipLink.focus();
				window.removeEventListener('keydown', handleFirstTab);
			}
		}
	}, true);

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
		  header.classList.add('down');
		  header.classList.remove('up');
		} else {
		  header.classList.add('up');
		  header.classList.remove('down');
		}
	} else {
		header.classList.remove('up', 'down');
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}